import {
  getShowcaseToppers as getShowcaseTopperEngine,
  OfferWithTopper as SharedOfferWithTopper,
  PILL_TOPPER_RULES,
  ResolvedTopper,
  TopperRule,
} from '@updater/ui-utilities/topper-logic';
import { OfferPair } from 'hooks/useTermGroupedOffers';

export type { ResolvedTopper, TopperRule };
export type OfferWithTopper = SharedOfferWithTopper<OfferPair>;

export function getShowcaseToppers(
  offers: OfferPair[],
  quizAnswers?: string[],
  primaryRule?: TopperRule
): OfferWithTopper[] {
  return getShowcaseTopperEngine(
    offers,
    quizAnswers?.length ? { answers: quizAnswers } : undefined,
    primaryRule
  );
}

export { PILL_TOPPER_RULES };
